import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

const Maintenance = () => {
  const { t } = useTranslation()
  const [timeLeft, setTimeLeft] = useState(8 * 24 * 60 * 60)

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft((s) => {
        if (s <= 0) {
          clearInterval(interval)
          return 0
        }
        return s - 1
      })
    }, 1000)
    return () => clearInterval(interval)
  }, [])

  const days = String(Math.floor(timeLeft / 86400)).padStart(2, "0")
  const hours = String(Math.floor((timeLeft % 86400) / 3600)).padStart(2, "0")
  const minutes = String(Math.floor((timeLeft % 3600) / 60)).padStart(2, "0")
  const seconds = String(timeLeft % 60).padStart(2, "0")

  const units = [
    { val: days, label: t("maintenance.days") },
    { val: hours, label: t("maintenance.hours") },
    { val: minutes, label: t("maintenance.minutes") },
    { val: seconds, label: t("maintenance.seconds") },
  ]

  return (
    <div className="relative min-h-screen bg-bg-main flex flex-col items-center justify-center px-4 sm:px-6 py-12 sm:py-16 overflow-hidden font-mono">
      {/* Grid */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage: `
            linear-gradient(rgb(var(--second-success) / 0.05) 1px, transparent 1px),
            linear-gradient(90deg, rgb(var(--second-success) / 0.05) 1px, transparent 1px)
          `,
          backgroundSize: "36px 36px",
        }}
      />

      {/* Glow */}
      <div
        className="absolute pointer-events-none bg-second-success/10"
        style={{
          top: "-60px",
          left: "50%",
          transform: "translateX(-50%)",
          width: "min(480px, 100vw)",
          height: "260px",
          filter: "blur(60px)",
          borderRadius: "50%",
        }}
      />

      {/* Badge */}
      <div className="relative z-10 inline-flex items-center gap-2 mb-6 sm:mb-8 px-3 sm:px-4 py-1.5 rounded-sm uppercase tracking-widest text-[9px] sm:text-[10px] font-bold border border-second-success/25 bg-second-success/[0.08] text-second-success">
        <span className="w-[7px] h-[7px] rounded-full bg-second-success animate-pulse shrink-0" />
        {t("maintenance.badge")}
      </div>

      {/* Gears (без изменений) */}
      <div className="relative z-10 w-14 h-14 sm:w-[72px] sm:h-[72px] mb-6 sm:mb-8">
        {/* SVG оставил как есть */}
        {/* ... */}
      </div>

      {/* Title */}
      <h1
        className="relative z-10 text-center font-bold tracking-tight text-text-main mb-3 sm:mb-4"
        style={{ fontFamily: "'Unbounded', sans-serif", fontSize: "clamp(18px, 5vw, 32px)" }}
      >
        {t("maintenance.title").split(t("maintenance.title_highlight"))[0]}
        <span className="text-second-success">{t("maintenance.title_highlight")}</span>
      </h1>

      {/* Subtitle */}
      <p className="relative z-10 text-center text-text-secondary text-xs sm:text-sm leading-relaxed max-w-[280px] sm:max-w-sm mb-6 sm:mb-8">
        {t("maintenance.subtitle_line1")}
        <br />
        {t("maintenance.subtitle_line2")}
      </p>

      {/* Divider */}
      <div className="relative z-10 w-8 sm:w-10 h-0.5 rounded mb-6 sm:mb-8 bg-second-success/50" />

      {/* Countdown */}
      <div className="relative z-10 flex items-end gap-1 sm:gap-2 w-full max-w-xs sm:max-w-sm">
        {units.map(({ val, label }, i) => (
          <React.Fragment key={i}>
            <div className="flex flex-col items-center gap-1 bg-bg-secondary border border-second-success/20 rounded-lg flex-1 px-1.5 sm:px-4 py-2.5 sm:py-3">
              <span
                className="text-second-success font-bold leading-none tabular-nums text-xl sm:text-[28px]"
                style={{ fontFamily: "'Unbounded', sans-serif" }}
              >
                {val}
              </span>
              <span className="text-[8px] sm:text-[10px] uppercase tracking-wider text-text-muted font-medium">
                {label}
              </span>
            </div>

            {i < 3 && (
              <span
                className="text-second-success/40 font-bold mb-3 sm:mb-4 text-base sm:text-xl select-none"
                style={{ fontFamily: "'Unbounded', sans-serif" }}
              >
                :
              </span>
            )}
          </React.Fragment>
        ))}
      </div>

      <style>{`
        @keyframes spin-reverse {
          from { transform: translate(-50%, -50%) rotate(0deg); }
          to   { transform: translate(-50%, -50%) rotate(-360deg); }
        }
      `}</style>
    </div>
  )
}

export default Maintenance
